import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import NumberDisplay from '../../../../../components/number-display';
import styles from './styles.css';

class SurveyRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
    this.requestOpportunitySurvey = this.requestOpportunitySurvey.bind(this);
    this.requestAddOpportunitySurvey = this.requestAddOpportunitySurvey.bind(this);
    this.handleRowGroupOpened = this.handleRowGroupOpened.bind(this);
  }

  componentDidMount() {
    this.props.api.addEventListener('rowGroupOpened', this.handleRowGroupOpened);
    this.checkProps(this.props);
  }

  componentWillUnmount() {
    this.props.api.removeEventListener('rowGroupOpened', this.handleRowGroupOpened);
  }

  handleRowGroupOpened() {
    this.checkProps(this.props);
  }

  checkProps(props) {
    const { node, context: { detailModes }, data, mode } = props;
    const currentMode = data ? detailModes[data.opportunity_id] : { expanded: false };
    const { expanded } = node;
    this.setState({ expanded: expanded && mode === currentMode });
  }

  requestOpportunitySurvey(e) {
    e.preventDefault();
    const { data, mode } = this.props;
    const { expanded } = this.state;
    this.props.requestShowSurvey(mode, data, !expanded);
  }

  requestAddOpportunitySurvey(e) {
    e.preventDefault();
    const { data } = this.props;
    this.props.requestAddOpportunitySurvey(data, true);
  }

  renderValue() {
    const { value } = this.props;
    const { expanded } = this.state;
    if (value === undefined || value === null) {
      return <Fa name="spinner" spin className="text-muted" />;
    }
    if (value === 0) {
      return (
        <a
          href=""
          onClick={this.requestAddOpportunitySurvey}
        >
          <Fa name="plus" /> request feedback
        </a>
      );
    }
    return [
      (
        <a
          href=""
          onClick={this.requestOpportunitySurvey}
          key="anchor"
          className={styles.expandBtn}
        >
          <Fa name={expanded ? 'minus-square-o' : 'plus-square-o'} />&nbsp;
        </a>
      ),
      (
        <a
          href=""
          onClick={this.requestOpportunitySurvey}
          key="stats"
        >
          <NumberDisplay value={value} precision={0} suffix="request" suffixIsUnit />
        </a>
      ),
    ];
  }
  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderValue();
    }
    return null;
  }
}

SurveyRenderer.propTypes = {
  value: PropTypes.number,
  data: PropTypes.shape({
    opportunity_id: PropTypes.string.isRequired,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
    expanded: PropTypes.bool,
  }),
  api: PropTypes.shape({
    addEventListener: PropTypes.func.isRequired,
    removeEventListener: PropTypes.func.isRequired,
  }).isRequired,
  mode: PropTypes.string.isRequired,
  requestShowSurvey: PropTypes.func,
  requestAddOpportunitySurvey: PropTypes.func,
  context: PropTypes.shape({
    detailModes: PropTypes.shape({}).isRequired,
  }).isRequired,
};
SurveyRenderer.defaultProps = {
  value: null,
  data: null,
  node: null,
  requestShowSurvey: () => {},
  requestAddOpportunitySurvey: () => {},
};
export default SurveyRenderer;
